import React, { useState, useEffect, useCallback, useRef } from 'react';
import { jsPDF as JsPdf } from 'jspdf';
import { saveAs } from 'file-saver-es';
import { Workbook } from 'exceljs';

import './permissiongroup_list.scss';

import {
    DataGrid,
    Sorting, Selection, HeaderFilter, Scrolling, SearchPanel,
    Export, Column, Toolbar, Item, LoadPanel

} from 'devextreme-react/data-grid';

import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import Button from 'devextreme-react/button';
import DropDownButton, { DropDownButtonTypes } from 'devextreme-react/drop-down-button';

import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridToXLSX } from 'devextreme/excel_exporter';


import { FormPopup, PermissiongroupNewForm, PermissiongroupPanel } from '../../components';
import { useMsal } from "@azure/msal-react";
import DataSource from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import { getApiToken } from '../../utils/authUtils.js';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { useNavigate } from 'react-router-dom';
import { onExporting } from '../../utils/exporter';
import { exportFormats } from '../../shared/constants';



const dropDownOptions = { width: 'auto' };



export const PermissiongroupList = () => {
      const { instance, accounts } = useMsal();
    const [gridDataSource, setGridDataSource] = useState();
    
    const [popupVisible, setPopupVisible] = useState(false);
    const [formDataDefaults, setFormDataDefaults] = useState({});
    const gridRef = useRef(null);
    const navigate = useNavigate();

    let newPermissiongroupData;

    useEffect(() => {
        getApiToken(instance, accounts).then(token => {
            setGridDataSource({
                store: createStore({
                    key: 'permissiongroupId',
                    loadUrl: `${process.env.REACT_APP_serverEndpoint}/Permissiongroup/Permissiongroups`,
                    insertUrl: `${process.env.REACT_APP_serverEndpoint}/Permissiongroup/InsertPermissiongroup`,
                    updateUrl: `${process.env.REACT_APP_serverEndpoint}/Permissiongroup/UpdatePermissiongroup`,
                    deleteUrl: `${process.env.REACT_APP_serverEndpoint}/Permissiongroup/DeletePermissiongroup`,
                    onBeforeSend: (method, ajaxOptions) => {
                        ajaxOptions.headers = {
                            'Authorization': "Bearer " + token
                        };
                    },
                })
            });

          
        });

    }, []);

    const changePopupVisibility = useCallback((isVisble) => {
        setPopupVisible(isVisble);
    }, []);


    const onAddPermissiongroupClick = useCallback(() => {
        setPopupVisible(true);
    }, []);

    const onRowClick = useCallback(({ data }) => {
        // setPermissiongroupId(data.permissiongroupId);
        // setPanelOpened(true);
        const permissiongroupId = data.permissiongroupId;
        navigate(`/settings/permissiongroup/edit/${permissiongroupId}`);
    }, []);


    

    const refresh = useCallback(() => {
        gridRef.current?.instance().refresh();
    }, []);

    const onDataChanged = useCallback((data) => {
        newPermissiongroupData = data;
    }, []);

    const onSaveClick = useCallback(() => {

        getApiToken(instance, accounts).then(token => {
            const datastore = createStore({
                key: 'permissiongroupId',
                insertUrl: `${process.env.REACT_APP_serverEndpoint}/Permissiongroup/InsertPermissiongroup`,
                onBeforeSend: (method, ajaxOptions) => {
                    ajaxOptions.headers = {
                        'Authorization': "Bearer " + token
                    };
                },
            });

            datastore.insert(newPermissiongroupData).then((data) => {

                notify({
                    message: `Neue Berechtigungsgruppe "${data.permissiongroupname}" gespeichert`,
                    position: { at: 'bottom center', my: 'bottom center' }
                }
                    ,
                    'success'
                );
                setFormDataDefaults({ ...formDataDefaults });
                setPopupVisible(false);
                refresh();
            }).catch((error) => {
                notify({
                    message: `Fehler beim Speichern der neuen Berechtigungsgruppe "${newPermissiongroupData.permissiongroupname}"`,
                    position: { at: 'bottom center', my: 'bottom center' }
                },
                    'error'
                );
            });
        });
    }, []);

    return (
        <div className='view permissiongroup-list'>
            <div className='view-wrapper view-wrapper-permissiongroup-list list-page'>
                <DataGrid
                    className='grid theme-dependent'
                    noDataText=''
                    focusedRowEnabled
                    height='100%'
                    dataSource={gridDataSource}
                    onRowClick={onRowClick}
                    onExporting={onExporting}
                    allowColumnReordering
                    showBorders
                    ref={gridRef}
                    remoteOperations={true}
                >
                    <LoadPanel showPane={false} />
                    <SearchPanel visible placeholder='Berechtigungsgruppe suchen' />
                    <Export enabled allowExportSelectedData formats={exportFormats} />
                    <Selection
                        selectAllMode='allPages'
                        showCheckBoxesMode='always'
                        mode='multiple'
                    />
                    <HeaderFilter visible />
                    <Sorting mode='multiple' />
                    <Scrolling mode='virtual' />
                    <Toolbar>
                        <Item location='before'>
                            <div className='grid-header'>Berechtigungsgruppen</div>
                        </Item>
                     
                        <Item location='after' locateInMenu='auto'>
                            <Button
                                icon='plus'
                                text='Neuer Berechtigungsgruppe'
                                type='default'
                                stylingMode='contained'
                                onClick={onAddPermissiongroupClick}
                            />
                        </Item>
                        <Item
                            location='after'
                            locateInMenu='auto'
                            showText='inMenu'
                            widget='dxButton'
                        >
                            <Button
                                icon='refresh'
                                text='Refresh'
                                stylingMode='text'
                                onClick={refresh}
                            />
                        </Item>
                        <Item location='after' locateInMenu='auto'>
                            <div className='separator' />
                        </Item>
                        <Item name='exportButton' />
                        <Item location='after' locateInMenu='auto'>
                            <div className='separator' />
                        </Item>
                        <Item name='searchPanel' locateInMenu='auto' />
                    </Toolbar>

                    <Column dataField="permissiongroupname" caption="Name" sortIndex={7} sortOrder='asc' hidingPriority={0} allowHiding={true} />
   


                </DataGrid>
                {/* <PermissiongroupPanel permissiongroupId={permissiongroupId} isOpened={isPanelOpened} changePanelOpened={changePanelOpened} changePanelPinned={changePanelPinned} /> */}
                <FormPopup title='Neuer Berechtigungsgruppe' visible={popupVisible} setVisible={changePopupVisibility} onSave={onSaveClick}>
                    <PermissiongroupNewForm initData={formDataDefaults} onDataChanged={onDataChanged} />
                </FormPopup>
            </div>
        </div>
    );
};

